import { Container } from '@chakra-ui/react';
import { Navigate, useParams } from 'react-router';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { CONTAINER_PADDINGS } from '../../components/Layouts/Container';
import { MOBILE_HEADER_HEIGHT } from '../../components/Layouts/MobileHeader';
import { OfferScorecardsForAgent } from '../../components/OfferScorecard/OfferScorecardsForAgent';
import {
  FeatureKey,
  useIsFeatureEnabledForPayload,
} from '../../hooks/useIsFeatureEnabledForPayload';

export const BuyerOfferScorecardsPage = () => {
  const {
    user,
    selectedOrganization,
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
  } = useAppContext();

  const isOfferScorecardEnabled = useIsFeatureEnabledForPayload({
    featureFlagKey: FeatureKey.OFFER_COACH,
    organizationId: selectedOrganization?.id,
    userId: user?.id,
  });
  const { buyerPartyId } = useParams();

  if (loadingOrganizations || loadingIsSelectedOrgAdmin) {
    return <CenterSpinner />;
  }

  if (isOfferScorecardEnabled === false) {
    return <Navigate to="/" />;
  }

  return (
    <Container
      height={{ base: `calc(100vh - ${MOBILE_HEADER_HEIGHT})`, md: '100vh' }}
      minWidth={{ base: '100%', md: '80%' }}
      {...CONTAINER_PADDINGS}
    >
      <OfferScorecardsForAgent partyId={buyerPartyId} />
    </Container>
  );
};
